import React from 'react';
import { Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-charcoal text-cream py-16" id="contacto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Branding */}
          <div>
            <h3 className="text-2xl font-serif font-light tracking-wider text-golden mb-4">
              KARI ROJAS
            </h3>
            <p className="text-sm text-cream-muted leading-relaxed">
              Consultora, Terapeuta y Mentora Financiera.
              Autora de "Mujer Construye tu Libertad Financiera"
            </p>
          </div>

          {/* Enlaces Rápidos */}
          <div>
            <h4 className="text-lg font-medium mb-4 text-golden">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-sm text-cream-muted hover:text-golden transition-colors">
                  Inicio
                </a>
              </li>
              <li>
                <a href="/diagnostico" className="text-sm text-cream-muted hover:text-golden transition-colors">
                  Diagnóstico Financiero
                </a>
              </li>
              <li>
                <a href="https://hotmart.com/es/club/transformacion-financiera-t" target="_blank" rel="noopener noreferrer" className="text-sm text-cream-muted hover:text-golden transition-colors">
                  Curso de Finanzas
                </a>
              </li>
              <li>
                <a href="https://go.viubux.com/kari-rojas" target="_blank" rel="noopener noreferrer" className="text-sm text-cream-muted hover:text-golden transition-colors">
                  Libro / Audiolibro
                </a>
              </li>
              <li>
                <a href="https://app.viubux.com/subscribe/2251799918000068?signature=d8a9e4de8d156162eee370104487ecc3d015091280aaa5271b2859f286ee11f4" target="_blank" rel="noopener noreferrer" className="text-sm text-cream-muted hover:text-golden transition-colors">
                  🎧 Suscríbete a mi canal de Viubux
                </a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-lg font-medium mb-4 text-golden">Contacto</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="https://instagram.com/karirojas.finanzas" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-sm text-cream-muted hover:text-golden transition-colors"
                >
                  <Instagram size={20} />
                  <span>@karirojas.finanzas</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:contacto@karirojas.com"
                  className="flex items-center space-x-3 text-sm text-cream-muted hover:text-golden transition-colors"
                >
                  <Mail size={20} />
                  <span>contacto@karirojas.com</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/525654919535" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-sm text-cream-muted hover:text-golden transition-colors"
                >
                  <Phone size={20} />
                  <span>WhatsApp: +52 56 5491 9535</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-cream-muted/20 text-center">
          <p className="text-sm text-cream-muted">
            © {new Date().getFullYear()} Kari Rojas. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
